import {
  SUBFORM_CLOSE,
  SUBFORM_OPEN,
  SUBFORM_REQUEST_ERROR,
  SUBFORM_CUSTOMER_RESULT,
  SUBFORM_WINDOW_RESIZE, SUBFORM_PERSONA_RESULT, SUBFORM_ADDRESS_RESULT
} from "./SubformsActions";

const initialState = {
  openedSubForm: null,
  windowSize: {
    height: window.document.documentElement.clientHeight,
    width: window.document.documentElement.clientWidth
  },
  customerResponse: {
    error: null,
    result: null
  },
  personaResponse: {
    error: null,
    result: null
  },
  addressResponse: {
    error: null,
    result: null
  },
  subformRequestError: null
};

export function subforms(state = initialState, action) {
  switch (action.type) {
    case SUBFORM_OPEN:
      return {
        ...state,
        openedSubForm: action.action
      };
    case SUBFORM_CLOSE:
      return {
        ...state,
        openedSubForm: null
      };
    case SUBFORM_REQUEST_ERROR:
      return {
        ...state,
        subformRequestError: action.action
      };
    case SUBFORM_WINDOW_RESIZE:
      return {
        ...state,
        windowSize: action.action
      };
    case SUBFORM_CUSTOMER_RESULT:
      return {
        ...state,
        customerResponse: action.response
      };
    case SUBFORM_PERSONA_RESULT:
      return {
        ...state,
        personaResponse: action.response
      };
    case SUBFORM_ADDRESS_RESULT:
      return {
        ...state,
        addressResponse: action.response
      };
    default:
      return state;
  }
};

export const getOpenedSubform = state => {
  return state.subforms.openedSubForm;
};

export const getWindowSizes = state => {
  return state.subforms.windowSize;
};



// WEBPACK FOOTER //
// ./src/order/subforms/SubformsReducers.js